import { TabItem as TabItemProps } from "./Navigation";
export { default } from "./Navigation";

export type TabItem = TabItemProps;
